<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        text: string;
        documentIdentifier?: string;
        isHit?: boolean;
    }>(),
    {
        documentIdentifier: '',
        isHit: true,
    },
);

const getDocumentTitle = () => {
    if (!props.text) return null;

    const lines = props.text.split(/\r?\n/).filter((line) => line.trim());
    if (lines.length === 0) return null;

    const firstLine = lines[0].trim();
    if (firstLine.length <= 100) {
        return firstLine;
    }
    return null;
};

const getDocumentContent = () => {
    if (!props.text) return '';

    const title = getDocumentTitle();
    if (!title) return props.text;

    const lines = props.text.split(/\r?\n/);
    let foundTitle = false;
    const contentLines: string[] = [];

    for (const line of lines) {
        if (!foundTitle && line.trim() === title) {
            foundTitle = true;
            continue;
        }
        if (foundTitle || line.trim() !== title) {
            contentLines.push(line);
        }
    }

    while (contentLines.length > 0 && contentLines[0].trim() === '') {
        contentLines.shift();
    }

    return contentLines.join('\n');
};
</script>

<template>
    <div :class="['edoc-document-card', { 'edoc-hit': isHit }]">
        <div class="edoc-header">
            <div class="edoc-icon">
                <span class="material-icons-outlined">description</span>
            </div>
            <div class="edoc-header-info">
                <div v-if="getDocumentTitle()" class="edoc-title">{{ getDocumentTitle() }}</div>
                <div v-if="documentIdentifier" class="edoc-identifier">
                    {{ documentIdentifier }}
                </div>
            </div>
        </div>

        <div class="edoc-body">
            <pre class="edoc-text">{{ getDocumentContent() || text }}</pre>
        </div>
    </div>
</template>
